import { Action, Dispatch } from 'redux'
import { setPrevEditedBreadAction } from 'reducks/bread/actions'

const setPrevEditedBread = (breadId: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(setPrevEditedBreadAction(breadId))
  }
}

export default setPrevEditedBread
